#@import GliveBooking.Views.Section
#@export GliveBooking.Views.Sections

class GliveBooking.Views.Sections extends BookingV2.Views.Collection

  module: 'glive-booking'

  tagName: 'ul'

  childView: GliveBooking.Views.Section

  attributes:
    'data-bhc': 'booking:sections'

  constructor: ->
    BookingV2.Views.Collection.apply this, arguments
    @on 'select', @select, this

  select: (section) ->
    @options.selected = section
    @render()
